import Link from "next/link";
import { cn } from "@/lib";
import { useTranslations } from "next-intl";
import { routes } from "@/routes";

interface IProps {
  handleOpenSideBar: () => void;
}

const HeaderNavigation = ({ handleOpenSideBar }: IProps) => {
  const t = useTranslations();
  return (
    <nav className="hidden basis-1/2 text-sm md:block xl:text-base">
      <ul className="flex grow text-center">
        <li
          id="header-navigation-services"
          onClick={handleOpenSideBar}
          className={cn("grow text-white")}
        >
          <span
            title={t("header.services")}
            className="hover:border-secondary-main hover:text-secondary-main cursor-pointer border-b border-transparent pb-1 transition-colors"
          >
            {t("header.services")}
          </span>
        </li>
        <li className={cn("grow text-white")}>
          <Link
            id="header-navigation-company-version"
            title={t("header.companyVersion")}
            href="https://hub.novin.one/"
            target="_blank"
            className="hover:border-secondary-main hover:text-secondary-main border-b border-transparent pb-1 transition-colors"
          >
            {t("header.companyVersion")}
          </Link>
        </li>
        <li className={cn("grow text-white")}>
          <Link
            id="header-navigation-blog"
            title={t("footer.blog")}
            className="hover:border-secondary-main hover:text-secondary-main border-b border-transparent pb-1 transition-colors"
            href={routes.blog.BLOG.primaryPath}
          >
            {t("footer.blog")}
          </Link>
        </li>
        <li className={cn("grow text-white")}>
          <Link
            id="header-navigation-faq"
            title={t("footer.faq")}
            className="hover:border-secondary-main hover:text-secondary-main border-b border-transparent pb-1 transition-colors"
            href={routes.blog.FAQ.primaryPath}
          >
            {t("footer.faq")}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default HeaderNavigation;
